import { Injectable } from '@angular/core';
import { MatSnackBar, MatSnackBarRef } from '@angular/material/snack-bar';

import { SnackbarKwoConnectComponent } from '@shared/components/snackbar-kwo-connect/snackbar-kwo-connect.component';
import { SnackbarUnlockComponent } from '@shared/components/snackbar-unlock/snackbar-unlock.component';

@Injectable({
	providedIn: 'root'
})
export class NotificationService {

	private snackBarRef: MatSnackBarRef<SnackbarUnlockComponent | SnackbarKwoConnectComponent>;

	constructor(private snackBar: MatSnackBar) {
	}

	public showBecomeMemberNotification() {

		this.snackBarRef = this.snackBar.openFromComponent(SnackbarUnlockComponent, {
			panelClass: ['kwo-snackbar', 'notify']
		});
	}

	public showKwoConnectNotification() {

		this.snackBarRef = this.snackBar.openFromComponent(SnackbarKwoConnectComponent, {
			panelClass: ['kwo-snackbar', 'notify']
		});
	}

	public hideNotifications() {

		if (this.snackBarRef)
			this.snackBarRef.dismiss();
	}
}